export default function DownloadLimit({ limit }: { limit: number | null }) {
  if (!limit) {
    return null;
  }
  
  return <em>The number of rows you can download is {limit}.</em>;
}
